// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header_doctrine_logo-module__wrapper--3qLEL{line-height:1}@media screen and (max-width: 48em){.header_doctrine_logo-module__hideOnMobile--3tprs{display:none}}\n", ""]);
// Exports
exports.locals = {
	"wrapper": "header_doctrine_logo-module__wrapper--3qLEL",
	"hideOnMobile": "header_doctrine_logo-module__hideOnMobile--3tprs"
};
module.exports = exports;
